import { useFormContext } from "react-hook-form";

import FormInput from "@/components/form-fields/form-input";
import { FileUploaderComponent } from "@/components/reusables/FileUpload";
import {
  allowAllFileExceptImage,
  allowedImageTypes,
} from "@/constants/constants";
import { TAddSubProduct } from "@/schemas/tools.schema";

const SubProductForm = (): JSX.Element => {
  const form = useFormContext<TAddSubProduct>();

  return (
    <div className='space-y-4'>
      <FormInput
        form={form}
        name='name'
        required
        label='Name'
        input={{
          placeholder: "Enter Product Name",
        }}
      />
      <FormInput
        form={form}
        name='modelNumber'
        required
        label='Model Number'
        input={{
          type: "number",
          placeholder: "Enter Model Number",
        }}
      />
      <FormInput
        form={form}
        name='images'
        render={(field, _, formState) => {
          return (
            <FileUploaderComponent
              field={field}
              formState={formState}
              acceptFileTypes={allowedImageTypes}
              isMultiple={true}
              labelsProps={{
                label: "Upload Image",
                showLabel: true,
              }}
              {...field}
            />
          );
        }}
      />
      <FormInput
        form={form}
        name='files'
        render={(field, _, formState) => {
          return (
            <FileUploaderComponent
              field={field}
              formState={formState}
              acceptFileTypes={allowAllFileExceptImage}
              allowVideoUpload={true}
              isForFileUpload={true}
              isMultiple={true}
              excludeFileLimit={true}
              labelsProps={{
                label: "Upload Files",
                showLabel: true,
              }}
              {...field}
            />
          );
        }}
      />
    </div>
  );
};

export default SubProductForm;
